import React from 'react';

import { GameLayout } from 'js/app/components/main/Games/components/GameLayout';
import { Loader } from 'js/components/common/Loader';

import {
    useIsCategoryLoading
} from 'js/app/components/main/Games/components/GameCategory/components/GameList/hooks/useIsCategoryLoading';
import { useCustomCategory } from 'js/app/components/main/Games/hooks/useCustomCategory';
import { useTranslations } from 'js/hooks/i18n';

import { useGameList } from './hooks/useGameList';
import { useSetDefaultCategory } from './hooks/useSetDefaultCategory';

import style from './GameList.scss';

export const GameList = ({ category }) => {
    const translation = useTranslations('playtech.mobile.system.gameList.');

    const { rowsInAllCat } = useCustomCategory(category.name);

    const gameList = useGameList(category);

    // LOADING STATE
    const checkIsCategoryLoading = useIsCategoryLoading();
    const isLoading = checkIsCategoryLoading(category);

    useSetDefaultCategory({ isLoading, category });

    if (isLoading) {
        return (
            <Loader className={style.loader} />
        );
    }

    if (!gameList.length) {
        return (
            <div className={style.noGamesAfterFilter}>
                {translation('empty')}
            </div>
        );
    }

    return (
        <GameLayout
            gameList={gameList}
            category={category}
            inlineGrid={rowsInAllCat}
        />
    );
};
